import styled from "@emotion/styled";
import { Flex } from "@radix-ui/themes";
import { observer } from "mobx-react-lite";
import type React from "react";
import { Suspense, lazy, useState } from "react";
import { useTranslation } from "react-i18next";

import { theme } from "@themes/themes";

import { ToggleGroup, ToggleGroupItem } from "@src/ui-kit";

const Orderbook = lazy(() => import("./Orderbook").then((m) => ({ default: m.Orderbook })));
const Trades = lazy(() => import("./Trades").then((m) => ({ default: m.Trades })));

export const OrderbookAndTrades: React.FC = observer(() => {
  const { t } = useTranslation();
  const [tab, setTab] = useState("orderbook");

  const TABS = [
    { label: t("orderbook.title"), value: "orderbook" as const },
    { label: t("orderbook.trades"), value: "trades" as const },
  ];

  const handleTabChange = (value: typeof tab) => {
    setTab(value);
  };

  return (
    <OrderbookAndTradesContainer>
      <Flex align="center" direction="column" width="100%">
        <TabsContainer>
          <ToggleGroup
            data-testid="orderbook-trades:tab-list"
            ItemComponent={ToggleGroupItemStyled}
            data-direction={tab}
            options={TABS}
            value={tab}
            fullWidth
            onChange={handleTabChange}
          />
        </TabsContainer>
        <ContentContainer data-testid="orderbook-trades:content">
          <Suspense fallback={null}>{tab === "orderbook" ? <Orderbook /> : <Trades />}</Suspense>
        </ContentContainer>
      </Flex>
    </OrderbookAndTradesContainer>
  );
});

const OrderbookAndTradesContainer = styled(Flex)`
  width: 100%;
  height: 100%;
  border: 1px solid ${theme.color("gray-6")};
  border-radius: 8px;
  background: ${theme.color("gray-2")};

  overflow: auto;
`;

const TabsContainer = styled(Flex)`
  width: 100%;
  padding: 12px 16px 0;
`;

const ToggleGroupItemStyled = styled(ToggleGroupItem)`
  ${theme.font.body12};
`;

const ContentContainer = styled(Flex)`
  flex: 1;
  width: 100%;
  min-height: 0;
  overflow: hidden;
`;
